import postTypes from './postTypes';

const getPageIdFromPostype = (postType, postData) => {
  const isPage = postType === postTypes.PAGE;
  const isTemplate = postType === postTypes.TEMPLATE;
  const isArticle = postType === postTypes.ARTICLE;
  const isBlog = postType === postTypes.POST;

  switch (true) {
    case isBlog:
      return postData?.postBy?.databaseId || postData?.postBy?.id;
    case isPage:
      return postData?.pageBy?.databaseId;
    case isTemplate:
      return postData?.templateBy?.databaseId;
    case isArticle:
      return postData?.articleBy?.databaseId;
    default:
      return null;
  }
};

export default getPageIdFromPostype;
